import { reactive } from 'vue'
import api from '../../api/v2/api'
import ReviewForm from '../../api/v2/forms/review'

class ReviewState {
  async create(reviewForm: ReviewForm){
    return await api.review.create(reviewForm)
  }
  async update(reviewId: number, reviewForm: ReviewForm){
    return await api.review.update(reviewId, reviewForm)
  }
}

// Wrap in reactive() for Vue 3 reactivity
export const reviewState = reactive(new ReviewState()) as ReviewState
